import type { FC, ReactNode } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as ContoursIcon } from '@/assets/icons/tools/contours.svg';
import { ReactComponent as NoContoursIcon } from '@/assets/icons/tools/nocontours.svg';
import { CheckboxRender } from '../../common/expandableTable/CheckboxRenderer.tsx';
import type { CheckboxRenderProps } from '../types';
import { useTheme } from '@mui/material/styles';
import { getMixedColor } from './getMixedColor';

export const ContoursCheckboxRender: FC<CheckboxRenderProps> = (props) => {
  return (
    <CheckboxRender
      {...props}
      mixedComponent={<MixedContour />}
      checkedComponent={<SvgIcon component={ContoursIcon} />}
      uncheckedComponent={<SvgIcon component={NoContoursIcon} />}
    />
  );
};

const MixedContour = (): ReactNode => {
  const theme = useTheme();
  return <SvgIcon component={ContoursIcon} style={{ fill: getMixedColor(theme) }} />;
};
